/**
 * The function should remove all extra spaces from
 * the input string, leaving only one space.
 * Example:
 * '   this    is  an      example         '
 * will be converted to
 * 'this is an example'
 *
 * @param {string} value - A string to remove extra spaces from
 * @returns {string}
 */
export function leaveOneSpace(value: string): string {
  return value.replace(/  +/g, ' ').trim();
}
